import * as React from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import MixedSelectDropdownMenuItem from '../item/MixedSelectDropdownMenuItem';
import MixedSelectDropdownMenuSelectAll from '../select-all/MixedSelectDropdownMenuSelectAll';

import { __t, applyTranslations } from 'utils/language';
import { getElementDetails } from '../../utils/mixed-select-dropdown';

import './mixed-select-dropdown-menu.scss';

import type { MixedSelectDropdownItem } from 'types';

import type { SyntheticEvent } from 'react';

applyTranslations(require('./mixed-select-dropdown-menu.i18n.json'));

type Props = {
  items: Array<MixedSelectDropdownItem>,
  withMulti?: boolean,
  withCheckboxes?: boolean,
  withColors?: boolean,
  withIcons?: boolean,
  withTruncate?: boolean,
  withSelectAll?: boolean,
  withSelectedInList?: boolean,
  withSmallSize?: boolean,
  withTags?: boolean,
  inputValue?: string,
  controlRef: React.RefObject<any>,
  menuClassName?: string,
  menuItemClassName?: string,
  onItemsToggle: (a: SyntheticEvent<HTMLElement>) => void,
  onItemsToggleAll: () => void,
  onMouseEnterMenu: () => void,
  onMouseLeaveMenu: () => void
};

type State = {
  top?: number,
  left?: number,
  width?: number
};

const msgKey = 'mixed_select_dropdown_menu';

class MixedSelectDropdownMenu extends React.PureComponent<Props, State> {
  state: State = {
    top: 0,
    left: 0,
    width: 0
  };

  componentDidMount() {
    this.setPlacementStyles();
  }

  componentDidUpdate() {
    this.setPlacementStyles();
  }

  setPlacementStyles(): void {
    const { controlRef } = this.props;
    const controlDetails = getElementDetails(controlRef.current) || {};

    this.setState({
      top: controlDetails.bottom,
      left: controlDetails.left,
      width: controlDetails.width
    });
  }

  renderEmpty(): React.ReactNode {
    return (
      <div className="mixed-select-dropdown-menu__empty">
        {__t(`${msgKey}.messages.empty`)}
      </div>
    );
  }

  renderItem = (item: MixedSelectDropdownItem): JSX.Element => {
    const {
      withMulti,
      withCheckboxes,
      withColors,
      withIcons,
      withTruncate,
      withSelectedInList,
      withSmallSize,
      withTags,
      inputValue,
      menuItemClassName,
      onItemsToggle
    } = this.props;

    const { width } = this.state;

    return (
      <MixedSelectDropdownMenuItem
        key={`mixed-select-dropdown-menu__item-${item.identifier}-${item.value}`}
        item={item}
        width={width}
        inputValue={inputValue}
        withMulti={withMulti}
        withCheckboxes={withCheckboxes}
        withColors={withColors}
        withIcons={withIcons}
        withTruncate={withTruncate}
        withSelectedInList={withSelectedInList}
        withSmallSize={withSmallSize}
        withTags={withTags}
        menuItemClassName={menuItemClassName}
        onItemsToggle={onItemsToggle}
      />
    );
  };

  renderItems(): React.ReactNode {
    const { items, withMulti, withSelectAll, onItemsToggleAll } = this.props;

    return (
      <div className="mixed-select-dropdown-menu__items">
        {
          withMulti && withSelectAll && !isEmpty(items) && (
            <MixedSelectDropdownMenuSelectAll
              onItemsToggleAll={onItemsToggleAll}
            />
          )
        }
        {
          items.map(this.renderItem)
        }
      </div>
    );
  }

  render(): React.ReactNode {
    const { items, menuClassName, onMouseEnterMenu, onMouseLeaveMenu } = this.props;
    const { top, left, width } = this.state;

    const menuClasses = classnames('mixed-select-dropdown-menu', {
      [`${String(menuClassName)}`]: Boolean(menuClassName)
    });

    return (
      <div
        className={menuClasses}
        style={{
          top: (top ?? 0) + window.scrollY,
          left: (left ?? 0) + window.scrollX,
          width
        }}
        onMouseEnter={onMouseEnterMenu}
        onMouseLeave={onMouseLeaveMenu}
      >
        {
          isEmpty(items)
            ? this.renderEmpty()
            : this.renderItems()
        }
      </div>
    );
  }
}

export default MixedSelectDropdownMenu;
